import classNames from 'classnames';
import { getBackgroundProp, resolveSetting } from '../../../utils/settingsHelper';
import { roundedOptions, shadowOptions } from '../../editor/Toolbar/options';

const getBgWithImage = (props, settings) => {
	const { backgroundImage, backgroundPosition, backgroundSize } = props;
	const bgColor = getBackgroundProp(props, settings);
	if (!backgroundImage) return bgColor;
	const imgLayer = `url(${backgroundImage}) ${backgroundPosition || 'center'} / ${backgroundSize || 'cover'} no-repeat`;
	return bgColor ? `${imgLayer}, ${bgColor}` : imgLayer;
};

const flexDirectionClass = { row: 'flex-row', column: 'flex-col' };
const flexDirectionClassSm = { row: '@sm:flex-row', column: '@sm:flex-col' };

export const getDivStyle = (props, settings) => {
	const { borderWidth, borderColor, color, alignItems, justifyContent, padding, mobilePadding, clipPath, minHeight, flexDirection, mobileFlexDirection, hoverBackground } = props;
	const hasResponsivePadding = Array.isArray(mobilePadding);
	return {
		color: resolveSetting(color, settings),
		background: getBgWithImage(props, settings),
		'--hover-background': hoverBackground ? resolveSetting(hoverBackground, settings) : undefined,
		borderColor: resolveSetting(borderColor, settings),
		borderWidth: `${resolveSetting(borderWidth, settings)}px`,
		display: 'flex',
		alignItems,
		justifyContent,
		flexDirection: mobileFlexDirection ? undefined : flexDirection,
		paddingTop: hasResponsivePadding ? undefined : (padding ? `${resolveSetting(padding[0], settings)}px` : ''),
		paddingRight: hasResponsivePadding ? undefined : (padding ? `${resolveSetting(padding[1], settings)}px` : ''),
		paddingBottom: hasResponsivePadding ? undefined : (padding ? `${resolveSetting(padding[2], settings)}px` : ''),
		paddingLeft: hasResponsivePadding ? undefined : (padding ? `${resolveSetting(padding[3], settings)}px` : ''),
		...(hasResponsivePadding ? {
			'--mobile-padding-top': `${resolveSetting(mobilePadding[0], settings)}px`,
			'--mobile-padding-right': `${resolveSetting(mobilePadding[1], settings)}px`,
			'--mobile-padding-bottom': `${resolveSetting(mobilePadding[2], settings)}px`,
			'--mobile-padding-left': `${resolveSetting(mobilePadding[3], settings)}px`,
			'--desktop-padding-top': padding ? `${resolveSetting(padding[0], settings)}px` : '0px',
			'--desktop-padding-right': padding ? `${resolveSetting(padding[1], settings)}px` : '0px',
			'--desktop-padding-bottom': padding ? `${resolveSetting(padding[2], settings)}px` : '0px',
			'--desktop-padding-left': padding ? `${resolveSetting(padding[3], settings)}px` : '0px',
		} : {}),
		clipPath: clipPath ? clipPath.trim().replace(/;+$/, '') : undefined,
		minHeight: minHeight ? (/^\d+$/.test(minHeight) ? `${minHeight}px` : minHeight) : undefined,
	};
};

export const getDivClasses = (props, settings) => {
	const { flexDirection, mobileFlexDirection, mobilePadding, rounded, shadow, overflowHidden, hoverBackground } = props;
	const hasResponsiveFlex = !!mobileFlexDirection;
	const hasResponsivePadding = Array.isArray(mobilePadding);
	return classNames(
		'flex',
		hasResponsiveFlex && flexDirectionClass[mobileFlexDirection],
		hasResponsiveFlex && flexDirectionClassSm[flexDirection],
		hasResponsivePadding && 'responsive-padding',
		{ [roundedOptions[resolveSetting(rounded, settings)]]: !!resolveSetting(rounded, settings) },
		shadowOptions[shadow],
		{ 'overflow-hidden': overflowHidden },
		{ 'transition-colors duration-200 hover:!bg-[var(--hover-background)]': !!resolveSetting(hoverBackground, settings) },
	);
};
